/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ language: NonNullable<unknown>, supported_languages: NonNullable<unknown> }} Dialog_Text_To_Audio_Language_Not_Supported_DescInputs */

const en_dialog_text_to_audio_language_not_supported_desc = /** @type {(inputs: Dialog_Text_To_Audio_Language_Not_Supported_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This text appears to be in ${i?.language}, which is not yet supported for audio conversion. Supported languages: ${i?.supported_languages}.`)
};

const es_dialog_text_to_audio_language_not_supported_desc = /** @type {(inputs: Dialog_Text_To_Audio_Language_Not_Supported_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este texto parece estar en ${i?.language}, que todavía no es compatible con la conversión a audio. Idiomas compatibles: ${i?.supported_languages}.`)
};

/**
* | output |
* | --- |
* | "This text appears to be in {language}, which is not yet supported for audio conversion. Supported languages: {supported_languages}." |
*
* @param {Dialog_Text_To_Audio_Language_Not_Supported_DescInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_language_not_supported_desc = /** @type {((inputs: Dialog_Text_To_Audio_Language_Not_Supported_DescInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Language_Not_Supported_DescInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_language_not_supported_desc(inputs)
	return en_dialog_text_to_audio_language_not_supported_desc(inputs)
});